export const UIState = Object.freeze({
    Collapsed: 'collapsed',
    Expanded: 'expanded'
});

export type UIStateType = (typeof UIState)[keyof typeof UIState];
